<template>
    <div>
        <div class="row mb-3">
            <div class="col-4">
                <select-accounting-firm-user
                    @collaborator-has-changed="setAccountingFirmUserId"
                />
            </div>
        </div>
        <loading v-if="loading" />
        <WebDataRocks
            v-if="pivotDisplay"
            :key="key"
            :report="pivotConfig"
            :global="pivotGlobal"
            toolbar
        />
    </div>
</template>

<script>
import { mapState } from 'vuex'
import webDataRocksFrLocalization from '../../../../../../lang/fr/webDataRocksFrLocalization.json'
import WebDataRocks from '../../../common/components/WebDataRocks.vue'
import config from './pivotChargeCollaboratorConfig.json'
import SelectAccountingFirmUser from '../../../activity_management/time-sheets/components/SelectAccountingFirmUser.vue'
import loading from '../../../common/components/loading.vue'

export default {
    name: 'pivotChargeCollaborator',

    components: {
        SelectAccountingFirmUser,
        WebDataRocks,
        loading,
    },

    data() {
        return {
            loading: false,
            accountingFirmUserIsSet: false,
            accountingFirmUser_id: 0,
            pivotDisplay: false,
            pivotConfig: {
                dataSource: {},
                slice: config.slice,
                options: config.options,
                formats: config.formats,
            },

            pivotGlobal: {
                localization: webDataRocksFrLocalization,
            },

            pivotData: null,

            key: 'wrd',
            ready: false,
        }
    },

    computed: {
        ...mapState({
            accountingFirmUser: (state) =>
                state.timeSheetsVM.filters.accountingFirmUser,
            year: (state) => state.browsing.year,
        }),
    },

    async created() {
        this.$store.commit('browsing/SET_PAGE_NAME', 'pivotChargeCollaborator')
        await this.setAccountingFirmUserId()
    },

    methods: {
        showPivot() {
            this.pivotDisplay = true
        },

        hidePivot() {
            this.pivotDisplay = false
        },

        async setAccountingFirmUserId() {
            this.pivotDisplay = false
            this.accountingFirmUser_id = this.accountingFirmUser
            if (this.accountingFirmUser_id > 0) {
                this.accountingFirmUserIsSet = true
                await this.getData()
                this.showPivot()
                this.updateKey()
            }
        },

        resetAccountingFirmUser() {
            this.accountingFirmUser_id = 0
            this.accountingFirmUserIsSet = false
            this.hidePivot()
        },

        async updateData() {
            this.hidePivot()
            await this.getData()
            this.showPivot()
            this.updateKey()
        },

        async getData() {
            this.loading = true
            try {
                const response = await this.$axios.get(
                    `reporting/charge/pivot/accountingFirmUsers/${this.accountingFirmUser_id}/${this.year}`
                )
                this.pivotData = response.data.data
                this.loading = false
                this.setInitialReport()
            } catch (error) {
                console.log(error)
            }
        },

        updateKey() {
            this.key = Date.now()
        },

        setInitialReport() {
            this.ready = false
            this.pivotConfig.dataSource = { data: this.pivotData }

            this.ready = true
            this.key = Date.now()
        },
    },
}
</script>

<style scoped></style>
